import { render, staticRenderFns } from "./cgorderprice.vue?vue&type=template&id=08ac3c3c&scoped=true"
import script from "./cgorderprice.vue?vue&type=script&lang=js"
export * from "./cgorderprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac3c3c",
  null
  
)

export default component.exports